export const msalConfig = {
  auth: {
    clientId: "45fab91c-0c3a-4332-808e-6a9930c0185e",
    authority:
      "https://login.microsoftonline.com/638456b8-8343-4e48-9ebe-4f5cf9a1997d",
    // redirectUri: "http://localhost:3000/",

    redirectUri: "https://delightful-moss-069f8e20f.7.azurestaticapps.net/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  // scopes: ["User.Read"],
  scopes: ["api://45fab91c-0c3a-4332-808e-6a9930c0185e/access_as_user"],
};
